export function hasValidURL(input: string): boolean {
  const urlPattern = /(?:https?:\/\/|www\.)[^\s/$.?#].[^\s]*/gi;
  return urlPattern.test(input);
}
